import moment from "moment/moment";

export function useDateFormatting() {
  const getNiceDateTime = value => {
    if (!value) return "";
    return moment(value).format("DD.MM.YYYY HH:mm");
  };

  return {
    getNiceDateTime
  };
}
